import { graphql } from '~publish/graphql'
import { useTypedMutation } from '~publish/hooks/useTypedMutation'

const CreatePostRecurrenceMutation = graphql(/* GraphQL */ `
  mutation CreatePostRecurrence(
    $id: PostId!
    $cadence: PostRecurrenceCadenceInput!
    $maxRecurrentPosts: Int!
  ) {
    createPostRecurrence(
      input: {
        id: $id
        cadence: $cadence
        maxRecurrentPosts: $maxRecurrentPosts
      }
    ) {
      __typename
      ... on VoidMutationError {
        message
      }
      ... on PostActionSuccess {
        post {
          id
          allowedActions
          recurrence {
            cadence {
              frequency
              frequencyStep
            }
            maxRecurrentPosts
            recurrentPostsLeft
            postNumber
          }
        }
      }
    }
  }
`)

const EditPostRecurrenceMutation = graphql(/* GraphQL */ `
  mutation EditPostRecurrence(
    $id: PostId!
    $cadence: PostRecurrenceCadenceInput
    $recurrentPostsLeft: Int
  ) {
    editPostRecurrence(
      input: {
        id: $id
        cadence: $cadence
        recurrentPostsLeft: $recurrentPostsLeft
      }
    ) {
      __typename
      ... on VoidMutationError {
        message
      }
      ... on PostActionSuccess {
        post {
          id
          allowedActions
          recurrence {
            cadence {
              frequency
              frequencyStep
            }
            maxRecurrentPosts
            recurrentPostsLeft
            postNumber
          }
        }
      }
    }
  }
`)

const CancelPostRecurrenceMutation = graphql(/* GraphQL */ `
  mutation CancelPostRecurrence($id: PostId!) {
    cancelPostRecurrence(input: { id: $id }) {
      __typename
      ... on VoidMutationError {
        message
      }
      ... on PostActionSuccess {
        post {
          id
          allowedActions
          recurrence {
            cadence {
              frequency
              frequencyStep
            }
            maxRecurrentPosts
            recurrentPostsLeft
            postNumber
          }
        }
      }
    }
  }
`)

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export const useCreatePostRecurrence = () =>
  useTypedMutation(
    CreatePostRecurrenceMutation,
    (data) => data.createPostRecurrence,
    {
      refetchQueries: ['GetPostList'],
      successTypename: 'PostActionSuccess',
    },
  )

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export const useEditPostRecurrence = () =>
  useTypedMutation(
    EditPostRecurrenceMutation,
    (data) => data.editPostRecurrence,
    {
      refetchQueries: ['GetPostList'],
      successTypename: 'PostActionSuccess',
    },
  )

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export const useCancelPostRecurrence = () =>
  useTypedMutation(
    CancelPostRecurrenceMutation,
    (data) => data.cancelPostRecurrence,
    {
      refetchQueries: ['GetPostList'],
      successTypename: 'PostActionSuccess',
    },
  )
